<template>

<div class="">
    <div class="logo2 bg-white " :class="{'bg-jacarta-900': darkMode}">
      <img src="~/assets/logo_dark1.png" alt="logo">
      <p class="text-3xl font-semibold text-pink-600 mt-5">{{code}}</p>
    <h1 class="mt-4 mx-3 text-3xl font-bold text-center tracking-tight text-gray-900 sm:text-5xl">{{texto1 ? texto1:'Ops! Parece que temos um erro aqui'}}
      </h1>
    <p class="mt-6 mx-3 text-base text-center leading-7 text-gray-600">{{texto2 ? texto2: 'Não estamos conseguindo conectar você aos nossos servidores...' }}</p>

    <div class="mt-10 mx-3 flex items-center justify-center gap-x-6">
      <button @click="navigateTo('/')" v-if="btn1"
        class="rounded-md bg-pink-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600">
        Voltar para página inicial</button>
        <button @click="refresh" v-if="btn2"
        class="rounded-md bg-pink-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600">Tentar
        novamente</button>
    </div>

    </div>
  </div>

</template>


<script setup>
const { logoutUser } = useFirebaseAuth()
const props = defineProps({
    code: {
        type: [Number, String],
        required: false,
        default: 500
    },
    returnv: {
        type: String,
        required: false
    },
    error: {
        type: String,
        required: false
    },
    texto1: {
        type: String,
        required: false
    },
    texto2: {
        type: String,
        required: false
    },
    btn1: {
        type: Boolean,
        default: false
    },
    btn2: {
        type: Boolean,
        default: false
    },
    darkMode: {
        type: Boolean,
        default: false
    }
})

function refresh() {
    window.location.reload()
}

if(props.code == 401){
    await logoutUser()
    navigateTo(`/login?ret=${props.returnv}`)
}
</script>

<style>

.logo2 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}


</style>
